import React, { Component } from "react";
import styles from "./controlGroups.module.scss";
import { withCompanyGroups } from "../../../shared/containers/containerCompanyGroups";
import { states } from "../../../reducers/queriesStates";
import Preloader from "../../../shared/items/static/preloader";
import ControlGroupsTable from "./ControlGroupsTable";
import ControlCreateGroup from "./ControlCreateGroup";
import ControlDeleteGroup from "./ControlDeleteGroup";

const PATHNAME = "/controls/groups/";

class ControlGroups extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const { onGetCompanyGroups, companyGroupsDataState, companyGroups, selectedGroup } = this.props;

    if (companyGroupsDataState === states.NOT_REQUESTED) {
      onGetCompanyGroups();
    }

    if (companyGroupsDataState === states.READY && companyGroups.length > 0) {
      if (window.location.pathname.includes(PATHNAME) && selectedGroup === null) {
        const id = window.location.pathname.replace(PATHNAME, "");

        if (id !== "") {
          this.onGroupHandleClick(id);
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const { companyGroups, selectedGroup, companyGroupsDataState } = this.props;

    if (companyGroupsDataState === states.READY && companyGroups.length > 0) {
      if (window.location.pathname.includes(PATHNAME) && selectedGroup === null) {
        const id = window.location.pathname.replace(PATHNAME, "");

        if (id !== "") {
          this.onGroupHandleClick(id);
        }
      }
    }
  }

  componentWillUnmount() {
    const { onSelectedGroup, selectedGroup } = this.props;
    if (selectedGroup !== null) {
      onSelectedGroup(null);
    }
  }

  onGroupHandleClick(id) {
    const { onSelectedGroup, companyGroups } = this.props;

    const group = companyGroups.filter((x) => {
      return x.id === id;
    })[0];

    window.history.replaceState(null, null, `${PATHNAME}${id}`);
    onSelectedGroup(group);
  }

  onUnselectedGroup(e) {
    const { onSelectedGroup } = this.props;
    window.history.replaceState(null, null, `${PATHNAME}`);
    onSelectedGroup(null);
  }

  render() {
    const { companyGroupsDataState, selectedGroup } = this.props;

    if (companyGroupsDataState === states.REQUEST) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <div className={styles.controlGroupsPanelContainer} onClick={this.onUnselectedGroup.bind(this)}>
        <div className={styles.groupsDataContainer}>
          {selectedGroup ? <ControlDeleteGroup /> : <ControlCreateGroup />}
          <ControlGroupsTable onHandleClick={this.onGroupHandleClick.bind(this)} />
        </div>
      </div>
    );
  }
}

export default withCompanyGroups(ControlGroups);
